import { PropsWithChildren } from 'react';
import { ViewResolver } from '@Components/ViewResolver';
import { RequestSearch } from '@Components/RequestSearch';
import { FormikProps } from 'formik';

interface FiltersWidgetProps extends PropsWithChildren {
  onSearchSubmit?: (value: string | null) => void;
  onHideSearch?: () => void;
  isOpen?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  // eslint-disable-next-line
  formik?: FormikProps<any>;
  showFilterBtn?: boolean;
  showTags?: boolean;
  closeBtn?: boolean;
  placeholder?: string;
}

const FiltersWidget: React.FC<FiltersWidgetProps> = ({
  children,
  onSearchSubmit,
  onHideSearch,
  isOpen,
  onClose,
  onOpen,
  formik,
  showFilterBtn = true,
  showTags = false,
  closeBtn = false,
  placeholder,
}) => {
  return (
    <ViewResolver
      desktop={
        <RequestSearch
          isOpen={isOpen}
          onClose={onClose}
          onOpen={onOpen}
          onSearchSubmit={onSearchSubmit}
          formik={formik}
          showTags={showTags}
          closeBtn={closeBtn}
          onHideSearch={onHideSearch}
          placeholder={placeholder}
          showFilterBtn={showFilterBtn}
        >
          {children}
        </RequestSearch>
      }
      mobile={
        <RequestSearch
          isOpen={isOpen}
          onClose={onClose}
          onOpen={onOpen}
          onSearchSubmit={onSearchSubmit}
          onHideSearch={onHideSearch}
          isMobile
          formik={formik}
          showTags={showTags}
          closeBtn={closeBtn}
          placeholder={placeholder}
          showFilterBtn={showFilterBtn}
        >
          {children}
        </RequestSearch>
      }
    />
  );
};

export default FiltersWidget;
